import React from "react";

export function IconNavigationCheck() {
    return (
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.86339 11.1158L3.08339 8.33583L2.13672 9.27583L5.86339 13.0025L13.8634 5.0025L12.9234 4.0625L5.86339 11.1158Z" fill="#FF5E00" />
      </svg>
        
    )
}